{
  "remove": "移除"
}
